import React from 'react';
import { useSelector } from 'react-redux';
import DefaultSummary from './DefaultSummary.js';
const AutoCall = (props) => {
    const autoCall = props.interaction.details;
    const lang = useSelector((s) => s.lang);
    return (React.createElement(DefaultSummary, { ...props, metaData: [
            {
                header: lang.autoCall.from,
                body: (React.createElement(React.Fragment, null,
                    "+",
                    autoCall.fromCountryCode,
                    " ",
                    autoCall.fromPhoneNumber)),
            },
            {
                header: lang.autoCall.called,
                body: (React.createElement(React.Fragment, null,
                    "+",
                    autoCall.toCountryCode,
                    " ",
                    autoCall.toPhoneNumber)),
            },
        ] },
        React.createElement("p", null, autoCall.transcript)));
};
export default AutoCall;
//# sourceMappingURL=AutoCall.js.map